import React, { useState, useEffect } from 'react';
import numeral from 'numeral';
import ApiCaller from "../../../../api/apiCaller";

const NearbyLocationMapTooltip = ({ objectToDisplay, pointerX, pointerY, onCloseButtonClick }) => {
  const [storeMetrics, setStoreMetrics] = useState(null);
  const getStoreMetrics = async () => {
    let uriPart = 'location_ids';
    let idToExtract = objectToDisplay.id; // This is location_id
    if (objectToDisplay.site_id) {
      uriPart = 'site_ids';
      idToExtract = objectToDisplay.site_id;
    }
    if (objectToDisplay.store_id) {
      uriPart = 'store_ids';
      idToExtract = objectToDisplay.store_id;
    }
    const uri = `site/comparison?${uriPart}=${idToExtract}`;
    const res = await ApiCaller.get(uri);
    if (res.status === 'ok') {
      setStoreMetrics(res?.result[0]);
    }
  }
  const handleOnTooltipCloseClick = () => {
    alert('fyvewyfuw');
    if (onCloseButtonClick) {
      onCloseButtonClick();
    }
  }
  useEffect(() => {
    getStoreMetrics();
  }, []);
  const isStore = objectToDisplay.site_id && objectToDisplay.store_id ? true : false;
  const isSite = objectToDisplay.site_id && !objectToDisplay.store_id ? true : false;
  return (
    <div style={{ position: 'absolute', zIndex: 3, pointerEvents: 'none', left: pointerX + 20, top: pointerY, ...styles.tooltipContainer }}>
      <span style={styles.title}>{objectToDisplay.name}</span>
      {isStore &&
        <span style={styles.badge}>Cửa hàng</span>
      }
      {isSite &&
        <span style={styles.badge}>Mặt bằng</span>
      }
      <br />
      <span style={styles.brandName}>{objectToDisplay.brand_name || objectToDisplay.brand?.name}</span>
      
      {objectToDisplay.full_address &&
        <span style={styles.address}><br/>{objectToDisplay.full_address || objectToDisplay.address}</span>
      }
      {storeMetrics &&
        <div style={styles.storeMetrics}>
          <span>Kiểu store: </span><span>{storeMetrics.store_format}</span><br />
          <span>Diện tích: </span><span>{storeMetrics.area} m2</span><br />
          <span>Tiền thuê: </span>
            <span>{numeral(storeMetrics.lease_rate).format('0,0')} VND / tháng</span>
            {storeMetrics.lease_rate_timestamp &&
              <span style={styles.timestamp}>({storeMetrics.lease_rate_timestamp})</span>
            }
          <br />
          <span>Số năm thuê: </span><span>{storeMetrics.lease_term_year} năm</span><br />
          <span>
            Doanh thu tháng: </span><span>{numeral(storeMetrics.revenue).format('0,0')} VND
            {storeMetrics.revenue_timestamp &&
              <span style={styles.timestamp}>({storeMetrics.revenue_timestamp})</span>
            }
            {storeMetrics.rental_calculation_method &&
              <span>{storeMetrics.rental_calculation_method}</span>
            }
          </span>
          <br />
          <span>
            Số ticket tháng: </span><span>{numeral(storeMetrics.instore_tickets).format('0,0')}
            {storeMetrics.instore_tickets_timestamp &&
              <span style={styles.timestamp}>({storeMetrics.instore_tickets_timestamp})</span>
            }
          </span>
          <br />
          <span>
            EBITDA: </span><span>{numeral(storeMetrics.ebitda).format('0,0')} VND
            {storeMetrics.ebitda_timestamp &&
              <span style={styles.timestamp}>({storeMetrics.ebitda_timestamp})</span>
            }
          </span>
          <br />
        </div>
      }
    </div>
  );
}

const styles = {
  tooltipContainer: {
    backgroundColor: 'var(--color-white)',
    padding: 12,
    boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
    borderRadius: 4,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  badge: {
    padding: '3px 6px',
    borderRadius: 12,
    border: '1px solid var(--color-accent-dark)',
    color: 'var(--color-accent-dark)',
    marginLeft: 6,
    fontSize: 12,
  },
  description: {
    fontSize: 14,
    whiteSpace: 'pre-line',
  },
  brandName: {
    fontWeight: 500,
    fontSize: 12,
  },
  address: {
    marginTop: 6,
    fontSize: 12,
  },
  storeMetrics: {
    paddingTop: 12,
    borderTop: '1px solid var(--color-line)',
    fontSize: 14,
  },
  timestamp: {
    fontSize: 12,
    marginLeft: 6,
    color: 'var(--color-muted)',
  },
};

export default NearbyLocationMapTooltip;